<template>
  <select class="form-control" v-model="value" v-on:change="onChange()">
    <option v-for="(month, index) in monthList" v-bind:value="month">{{month}}</option>
  </select>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    teamData: {
      type: Object,
    },
    currentMonth: {
      type: String,
    },
  },
  computed: {
    monthList: function() {
      const list = [];

      if (this.teamData) {
        const now = moment().startOf('months');
        const start = moment(this.teamData.created_at).startOf('months');
        const months = (now.diff(start, 'months'));
        list.push(now.format('MMMM YYYY'));

        for (let i = 0; i < months; i += 1) {
          list.push(now.subtract(1, 'months').format('MMMM YYYY'));
        }
      }

      return list;
    },
  },
  data: function () {
    return {
      value: moment().startOf('month').format('MMMM YYYY'),
    };
  },
  methods: {
    onChange: function () {
      this.$emit('input', this.value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MonthList.vue?b8dfbc46